import { useSyncExternalStore } from 'react';
import { getConnections } from '../actions/getConnections';
import { watchConnections } from '../actions/watchConnections';
import { useContext } from '../context';

export function useConnections() {
  const { config } = useContext();

  return useSyncExternalStore(
    (onChange) => watchConnections(config, { onChange }),
    () => getConnections(config),
    () => getConnections(config)
  );
}
